import React from "react";
import styles from "./overview_sec_title.module.scss";

const OverviewSecTitle = (props) => {
  return (
    <>
      <div className={styles.top_rank_title}>
        <h3>{props.title}</h3>
      </div>
      <div className={styles.top_rank_desc}>
        <p>{props.description}</p>
      </div>
    </>
  );
};

export default OverviewSecTitle;
